export enum CurrencyEnum {
  Rub = 'RUB',
  Usd = 'USD',
}
export const currencies: CurrencyEnum[] = [
  CurrencyEnum.Rub,
  CurrencyEnum.Usd,
]
